export enum FeatureTypes {
    DASHBOARD = 'DASHBOARD'
}
